<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <div v-if="types.length > 0">
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-form>
              <b-row>
                <!-- Field: fileData -->
                <b-col
                    cols="12"
                >
                  <h2>بارگذاری مدیای جدید</h2>

                  <b-col cols="12" md="4">
                    <span>انتخاب تیپ شخصیتی :</span>
                    <b-form-group
                        label-cols="12"
                    >
                      <v-select
                          class=""
                          v-model="selectedType"
                          :clearable="false"
                          label="subTitle"
                          :options="types"
                          :reduce="subTitle => subTitle.typeId"
                      />
                    </b-form-group>
                  </b-col>

                  <b-button
                      class="mt-2 col-12 col-md-4"
                      variant="warning"
                      @click="$refs.refInputEl2.click()"
                  >
                    <input
                        ref="refInputEl2"
                        class="d-none"
                        type="file"
                        @change="select"
                    >
                    <span class="">بارگذاری فایل</span>
                  </b-button>
                  <b-button
                      :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                      class="mt-2 mb-sm-0 ml-2 col-12 col-md-2"
                      variant="primary"
                      @click="upload"
                  >
                    ثبت
                  </b-button>

                  <b-alert
                      :show="true"
                      class="col-md-6 col-12"
                      variant="warning"
                  >
                    <div class="alert-body mt-2">
                      <feather-icon
                          class="mr-25"
                          icon="CheckIcon"
                      />
                      <span class="ml-25">توجه : اگر مدیای مورد نظر شما برای آپلود ویدیو میباشد به صورت پیشفرض با کیفیت 1080 ثبت میشود.</span>
                    </div>
                  </b-alert>
                </b-col>
              </b-row>
            </b-form>

            <b-progress
                v-if="uploaded !== 0 && uploaded !== 100"
                :value="uploaded"
                class=" mt-2"
                max="100"
                variant="primary"
            />

            <b-alert
                :show="done === true"
                class="col-md-2 col-12"
                variant="success"
            >
              <div class="alert-body mt-2">
                <feather-icon
                    class="mr-25"
                    icon="CheckIcon"
                />
                <span class="ml-25">فایل شما آپلود شده است.</span>
              </div>
            </b-alert>
            <b-alert
                :show="errorAlert"
                class="col-md-2 col-12"
                variant="danger"
            >
              <div class="alert-body mt-2">
                <feather-icon
                    class="mr-25"
                    icon="CloseIcon"
                />
                <span class="ml-25">آپلود فایل با مشکل مواجه شد!</span>
              </div>
            </b-alert>
          </b-card>

          <div v-if="productType === '8'" class="w-100">
            <b-card>
              <b-row v-for="(item,idx) in types" :key="idx">
                <b-col md="12">
                  <b-card class="text-center">
                    <b-tabs
                        nav-class="mb-3"
                        pills
                    >
                      <app-collapse accordion class="col-12">
                        <app-collapse-item :title="item.subTitle.split('.')[0]">
                          <template v-if="item.media">
                            <video
                                class="col-12"
                                controls
                                style="max-height: 30rem;"
                            >
                              <source
                                  :src="`${baseURL}`+item.media.pictureUrl"
                                  size=""
                                  type=""
                              />
                            </video>

                            <b-button
                                v-b-modal.modal-video-delete
                                class="m-2"
                                variant="danger"
                                @click="tempVideoObject = item.media"
                            >
                              <feather-icon class="" icon="TrashIcon" size="20"/>
                            </b-button>

<!--                            <b-button-->
<!--                                v-b-modal.modal-edit-name-->
<!--                                class="m-2"-->
<!--                                variant="primary"-->
<!--                                @click="showChangeNameModal(item.media.mediaId,item.media.title.split('.')[0])"-->
<!--                            >-->
<!--                              <feather-icon icon="EditIcon" size="20"/>-->
<!--                            </b-button>-->
                          </template>
                          <b-alert
                              v-else
                              :show="true"
                              class="col-md-6 col-12"
                              variant="danger"
                          >
                            <div class="alert-body mt-2">
                              <span class="ml-25">ویدیویی برای این تیپ آپلود نشده است.</span>
                            </div>
                          </b-alert>
                        </app-collapse-item>
                      </app-collapse>

                    </b-tabs>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-modal
        id="modal-video-delete"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="sendMediaRemoveRequest()"
    >
      <span>حذف شود؟</span>
    </b-modal>
    <b-modal
        id="modal-edit-name"
        cancelTitle="انصراف"
        centered
        ok-title="ثبت"
        title="ویرایش نام فایل"
        @ok="updateMediaName"
    >
      <input v-model="newName" type="text" @keydown.enter="updateMediaName">
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BAlert,
  BButton,
  BCard,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BModal,
  BOverlay,
  BProgress,
  BRow,
  BTab,
  BTabs
} from "bootstrap-vue";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import vSelect from "vue-select";
import axios from "axios";
import {getUserData} from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {
  MediaDeleteByPictureUrlRequest,
  ProductGetProductsMediasForAdminRequest,
  ProductSetMediaGroupTypeRequest,
  ProductSetReachableRequest
} from "@/libs/Api/Product";
import {MediaChangeMediaNameRequest, MediaChangePriorityRequest} from "@/libs/Api/Media";
import Helper from "@/libs/Helper";
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {ArvanCloudVideoCreateRequest, DeleteArvanVideo} from "@/libs/Api/ArvanCloud";
import {PsychologicalTestAnswerGetPersonalityTestTypes} from "@/libs/Api/Test";

export default {
  title: 'مدیای تست - پنل ادمین نهایی شو',
  name: "AddMediaToTest",
  data() {
    return {
      productId: this.$route.params.id,
      productType: this.$route.query.productType,
      userToken: getUserData().token,
      medias: null,
      errorAlert: false,
      done: null,
      overlay: true,
      deleteItem: null,
      baseURL: Helper.baseUrl,
      file: null,
      chunks: [],
      uploaded: 0,
      uploaded2: 0,
      namePictureURL: null,
      priorityPictureURL: null,
      newName: '',
      newPriority: '',
      uploadParentId: null,
      quality: null,
      selectedMediaIdForMediaGroup: null,
      selectedTypeForMediaGroup: null,
      tempVideoObject: null,
      arvanObj: {
        title: '',
        description: '',
        mediaId: null
      },
      selectedIsReachableType: null,
      selectedMediaIdForIsReachableType: null,
      types: [],
      selectedType:null,
    };
  },
  async created() {
    // await this.getProductMedias();
    await this.getTypes();
  },
  computed: {
    formData() {
      let formData = new FormData;

      if (this.file !== null) {
        // formData.set('is_last', this.chunks.length === 1);
        // formData.set('file', this.chunks[0], `${this.file.name}`);
        formData.set('TypeId', this.selectedType)
        formData.set('file', this.file, `${this.file.name}`)
      }
      return formData;
    },
    config() {
      return {
        method: 'POST',
        data: this.formData,
        withCredentials: true,
        url: Helper.baseUrl + 'api/PsychologicalTestAnswer/UploadPersonalityTestVideo',
        headers: {
          "Content-Type": "multipart/form-data",
          'Authorization': this.userToken,
          'Token': this.userToken,
        },
        onUploadProgress: progressEvent => {
          this.uploaded = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      };
    },
  },
  methods: {
    upload() {
      if (!this.selectedType){
        return this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `اخطار`,
            icon: 'CheckIcon',
            variant: 'danger',
            text: 'انتخاب تیپ شخصیتی ابزامی است.',
          },
        })
      }
      this.overlay = true;
      axios(this.config).then(response => {

        if (response.data.isSuccess === false) {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات ناموفق`,
              icon: 'CheckIcon',
              variant: 'danger',
              text: response.data.errorMessage,
            },
          })
          this.overlay = false;
          this.errorAlert = true;
        } else {
          this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `فایل با موفقیت آپلود شد.`,
            },
          })
          this.overlay = false;
          this.done = true;
          window.location.reload();
        }
      }).catch(error => {
        this.overlay = false;
        this.errorAlert = true;
        console.log(error);
      });
    },
    async getTypes() {
      let _this = this;
      _this.overlay = true

      let psychologicalTestAnswerGetPersonalityTestTypes = new PsychologicalTestAnswerGetPersonalityTestTypes(_this);
      await psychologicalTestAnswerGetPersonalityTestTypes.fetch(function (content) {
        _this.overlay = false;
        _this.types = content.data
      }, function (content) {
        _this.overlay = false;
      });
    },
    async getProductMedias() {
      let _this = this;
      _this.overlay = true

      let productGetProductsMediasRequest = new ProductGetProductsMediasForAdminRequest(_this);
      productGetProductsMediasRequest.setId(_this.productId)
      await productGetProductsMediasRequest.fetch(function (content) {
        _this.overlay = false;
        _this.medias = content;
      }, function (content) {
        _this.overlay = false;
      });
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param
    },
    showChangeNameModal(param1, param2) {
      let _this = this;
      _this.namePictureURL = param1;
      _this.newName = param2
    },
    showChangePriorityModal(param1) {
      let _this = this;
      _this.priorityPictureURL = param1;
      _this.newPriority = ''
    },
    select(event) {
      this.file = event.target.files.item(0);
    },
    async deleteMedia(param) {
      let _this = this;
      _this.overlay = true

      let mediaDeleteByPictureUrlRequest = new MediaDeleteByPictureUrlRequest(_this);
      mediaDeleteByPictureUrlRequest.setSocialMediaId(param);
      await mediaDeleteByPictureUrlRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    async updateMediaName() {
      let _this = this;
      _this.overlay = true

      let data = {
        socialMediaId: _this.namePictureURL,
        newName: _this.newName
      }

      let mediaChangeMediaNameRequest = new MediaChangeMediaNameRequest(_this);
      mediaChangeMediaNameRequest.setParams(data);
      await mediaChangeMediaNameRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    setUploadParentId(id, q) {
      let _this = this;
      _this.uploadParentId = id;
      _this.quality = q;
    },
    async updateMediaPriority() {
      let _this = this;
      _this.overlay = true

      let data = {
        socialMediaId: _this.priorityPictureURL,
        priority: _this.newPriority
      }

      let mediaChangePriorityRequest = new MediaChangePriorityRequest(_this);
      mediaChangePriorityRequest.setParams(data);
      await mediaChangePriorityRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    selectMediaForMediaGroup(mediaId, type) {
      this.selectedMediaIdForMediaGroup = mediaId;
      this.selectedTypeForMediaGroup = type;
    },
    selectMediaForIsReachable(mediaId, type) {
      this.selectedMediaIdForIsReachableType = mediaId;
      this.selectedIsReachableType = type;
    },
    async updateMediaGroupType() {
      let _this = this;
      _this.overlay = true

      let data = {
        mediaId: _this.selectedMediaIdForMediaGroup,
        type: _this.selectedTypeForMediaGroup
      }

      let productSetMediaGroupTypeRequest = new ProductSetMediaGroupTypeRequest(_this);
      productSetMediaGroupTypeRequest.setParams(data);
      await productSetMediaGroupTypeRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    async arvanCreate() {
      let _this = this;
      _this.overlay = true;

      if (_this.arvanObj.title.length === 0) {
        return _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عنوان فایل الزامی است.`,
          },
        })
      }

      let arvanCloudVideoCreateRequest = new ArvanCloudVideoCreateRequest(_this);
      arvanCloudVideoCreateRequest.setParams(_this.arvanObj);
      await arvanCloudVideoCreateRequest.fetch(function (content) {
        _this.overlay = false
        if (content.isSuccess) {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات موفق`,
              icon: 'CheckIcon',
              variant: 'success',
              text: `درخواست شما ارسال شد.`,
            },
          })
        } else {
          _this.$toast({
            component: ToastificationContent,
            position: 'bottom-center',
            props: {
              title: `عملیات ناموفق`,
              icon: 'CloseIcon',
              variant: 'danger',
              text: `عملیات انجام نشد.`,
            },
          })
        }
        window.location.reload();
      }, function (error) {
        _this.overlay = false
      })
    },
    async deleteVideoMedia() {
      let _this = this;
      _this.overlay = true

      let mediaDeleteByPictureUrlRequest = new MediaDeleteByPictureUrlRequest(_this);
      mediaDeleteByPictureUrlRequest.setSocialMediaId(_this.tempVideoObject.pictureUrl);
      await mediaDeleteByPictureUrlRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
    async sendMediaRemoveRequest() {
      if (!this.tempVideoObject || !this.tempVideoObject.arvanCloudVideoId) {
        try {
          await this.deleteVideoMedia()
        } catch (error) {
          console.error(error);
        } finally {
          this.overlay = false;
        }
      } else {
        await this.sendDeleteArvanVideo();
      }
    },
    async sendDeleteArvanVideo() {
      try {
        this.overlay = true;
        let _this = this;
        let deleteArvanVideo = new DeleteArvanVideo(_this);
        deleteArvanVideo.setRequestParam({
          videoId: _this.tempVideoObject.arvanCloudVideoId,
        });
        await deleteArvanVideo.delete((response) => {
          if (response.isSuccess) {
            _this.deleteVideoMedia();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
      }
    },
    async setReachableMedia() {
      let _this = this;
      _this.overlay = true

      let data = {
        mediaId: _this.selectedMediaIdForIsReachableType,
        isReachable: _this.selectedIsReachableType
      }

      let productSetReachableRequest = new ProductSetReachableRequest(_this);
      productSetReachableRequest.setParams(data);
      await productSetReachableRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        window.location.reload();
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات ناموفق`,
            icon: 'CloseIcon',
            variant: 'danger',
            text: `عملیات انجام نشد.`,
          },
        })
      })
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BAlert,
    BTab,
    BTabs,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    BProgress,
    BModal,
    AppCollapse,
    AppCollapseItem,
    vSelect,
    ValidationProvider, ValidationObserver
  },
}
</script>

<style scoped>

</style>
